export default __webpack_public_path__ + "static/media/about-toad.a849f5d4.webp";